import { lazy } from 'libs/loadable';

export default lazy(() => import('./App'));
